import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { Populations } from 'src/app/shared/utilities/populations';
import { Tags } from 'src/app/shared/utilities/tags';

@Component({
  selector: 'fgb-games-page',
  templateUrl: './games-page.component.html',
  styleUrls: ['./games-page.component.scss'],
})
export class GamesPageComponent implements OnInit {
  populations = Populations;
  tags = Tags;
  isKid: boolean;
  isMember: boolean;
  isAdultMember: boolean;
  isClub1901: boolean;
  isSTH: boolean;
  isSTHKid: boolean;
  isMemberKid: boolean;

  constructor(
    private populationQuery: PopulationQuery,
    private memberQuery: MemberQuery,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.isKid = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.isMember = this.populationQuery.userInPopulation([this.populations.Default]);
    this.isClub1901 = this.populationQuery.userInPopulation([this.populations.Club1901]);
    const userContext = this.memberQuery.getUserContext();
    const customerTags = userContext.customerTags;
    const isKidsPopulation = this.populationQuery.userInPopulation([this.populations.Kids]);
    this.isAdultMember = customerTags?.some((t) => t.TagName === Tags.Member.TagName) ?? false;
    this.isSTH = customerTags?.some((t) => t.TagName === Tags.AdultSTH.TagName) ?? false;
    this.isSTHKid = isKidsPopulation && (customerTags?.some((t) => t.TagName === Tags.JuniorSTH.TagName) ?? false);
    this.isMemberKid = isKidsPopulation && (customerTags?.some((t) => t.TagName === Tags.JuniorMembers.TagName) ?? false);
  }

  navigateToPaP() {
    if (this.isSTH || this.isSTHKid || this.isClub1901) {
      this.router.navigate(['/games/pickaplayer']);
    } else {
      window.location.href = this.translate.instant('games.page.pap.upgrade.url');
    }
  }
}
